import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import { bindActionCreators, compose } from 'redux';
import { connect } from 'react-redux';
import * as activityConstants from '../../../../activity.constants';
import MultiCardsWrapper from '../../../../../../common/components/Cards/CardWrapper/MultiCardsWrapper';
import * as activityActions from '../../../../activity.actions';
import ImportPromoCodesFile from './ImportPromoCodesFile';
import DownloadCsvFromInput
  from '../../../../../../common/components/FormInputFields/DownloadCsvFromInput/DownloadCsvFromInput';
import * as activitySelectors from '../../../../activity.selectors';

class PromoCodesImported extends React.PureComponent {

  static propTypes = {
    actions: PropTypes.func,
    validationErrors: PropTypes.object,
    selectedPromoCodesImportedMode: PropTypes.string,
    isModalInProgress: PropTypes.bool,
    tempBulk: PropTypes.object,
    index: PropTypes.number,
  };

  get promoCodesImportedFileUploadErrors() {
    return this.props.validationErrors
        ? this.props.validationErrors.get([activityConstants.IMPORT_PROMO_CODES_UPLOAD_FILE_MODE])
        : null;
  }

  get importedFileName() {
    if (this.props.tempBulk) {
      const fullFileName = this.props.tempBulk.toJS().tempFileUploaded.dataFile.objectName;
      return fullFileName ? fullFileName.substring(fullFileName.lastIndexOf('/') + 1) : null;
    }
    return null;
  }

  get promoCodesCopyPasteErrors() {
    return this.props.validationErrors
        ? this.props.validationErrors.get(activityConstants.IMPORT_PROMO_CODES_COPY_PASTE_MODE)
        : null;
  }

  get isPastingImportedPromoCodes() {
    return this.props.tempBulk
        ? this.props.tempBulk.getIn([activityConstants.PROMO_CODE_IMPORTED_TEMP_COPY_PASTE, activityConstants.IMPORT_PROMO_CODES_PASTING])
        : false;
  }

  getParsedImportedPromoCodesCopyPasteData() {
    if (this.props.tempBulk) {
      const inputValue = this.props.tempBulk.getIn([activityConstants.PROMO_CODE_IMPORTED_TEMP_COPY_PASTE, activityConstants.PROMO_CODE_BULK_INPUT_VALUE]);
      if (inputValue && inputValue.size > 0) {
        return inputValue.toJS().join(',');
      }
    }
    return '';
  }

  selectImportCard = (mode) => this.props.actions.updatePromoCodesImported(null, mode);

  getPromoCodesImportedCards() {
    const copyPasteCard = (<DownloadCsvFromInput
      saveModalInProcess={this.props.isModalInProgress}
      error={this.promoCodesCopyPasteErrors}
      clearValue={this.props.actions.clearImportedPromoCodesCopyPaste}
      goingToPasteImportMembersData={this.props.actions.goingToPasteImportedPromoCodesData}
      inputValue={this.getParsedImportedPromoCodesCopyPasteData()}
      isPasting={this.isPastingImportedPromoCodes}
      filename={'promoCodesKeys.csv'}
      name={'promoCodesKeys'}
      onChange={this.props.actions.updatePromoCodesImported}
      prefix={'filters.imported.pasteCodes.input'}
    />);

    const importFileCard = (
      <ImportPromoCodesFile
        index={this.props.index}
        automationIdPrefix={'promoCodes.imported.file.input'}
        error={this.promoCodesImportedFileUploadErrors}
        onUpload={() => this.selectImportCard(activityConstants.IMPORT_PROMO_CODES_UPLOAD_FILE_MODE)}
        uploadInProgress={this.props.isModalInProgress}
        uploadedFileName={this.importedFileName}
      />);

    return [
      {
        title: 'activity.globalConditions.members.radioBtn.import.members.copy.paste.title',
        description: 'activity.globalConditions.members.radioBtn.import.members.copy.paste.title',
        content: copyPasteCard,
        id: activityConstants.IMPORT_PROMO_CODES_COPY_PASTE_MODE
      },
      {
        title: 'activity.promoCodes.imported.upload.file.title',
        description: 'activity.promoCodes.imported.upload.file.description',
        content: importFileCard,
        id: activityConstants.IMPORT_PROMO_CODES_UPLOAD_FILE_MODE
      }
    ];
  }


  render() {
    return (
      <div id={'customCardsModal'}>
        {
          <MultiCardsWrapper
            automationIdPrefix={'promoCodesImported'}
            cards={this.getPromoCodesImportedCards()}
            selectCard={this.selectImportCard}
            selectedCardId={this.props.selectedPromoCodesImportedMode}
          >
          </MultiCardsWrapper>
        }
      </div>
    );
  }
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(activityActions, dispatch)
  };
}

const mapStateToProps = (state) => ({
  saveModalInProcess: activitySelectors.getPromoCodesImportedInProgress(state),
});

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default compose(
  injectIntl,
  withConnect
)(PromoCodesImported);
